import {
  openModalAttr,
  openModalPropsAttr,
} from '#/snippets/open-modal.attributes';
import { showModal } from '#/zustand-stores/modalStore';

export function openModalElement(el: Element, event: MouseEvent) {
  const type = el.getAttribute(openModalAttr);
  if (!type) return null;

  event.preventDefault();
  const rawProps = el.getAttribute(openModalPropsAttr);
  const props: unknown = rawProps ? JSON.parse(rawProps) : {};

  showModal(
    // @ts-expect-error not much we can do unless we import all types
    type,
    props,
  );
}
